// extracted by mini-css-extract-plugin
module.exports = {"modalForm":"style-module__modalForm___1ZeBz"};